import React from 'react';

import { AdfoxBanner } from 'shared/components/AdfoxBanner';
import { AdfoxContextProvider, TAdfoxContextProviderProps } from 'shared/context/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: TAdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'TgbBottomBanners',
};
const P_PARAMS: TAdfoxContextProviderProps['pParams'] = { p1: 'ddcga', p2: 'fkhj' };
const SIZE: TAdfoxContextProviderProps['size'] = { width: '100%', height: 276 };

export const TgbBottomBannersContainer: React.FC = () => {
  return (
    <AdfoxContextProvider
      bannerPlace="bottom"
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    >
      <AdfoxBanner />
    </AdfoxContextProvider>
  );
};
